import { render, staticRenderFns } from "./TsGiftcard.vue?vue&type=template&id=1471ed94&scoped=true"
import script from "./TsGiftcard.vue?vue&type=script&lang=js"
export * from "./TsGiftcard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1471ed94",
  null
  
)

export default component.exports